exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Colors-module__wrapper___2Fack{position:relative;z-index:5;display:grid;justify-content:center;gap:.5rem}@media screen and (min-width:1325px){.Colors-module__wrapper___2Fack{position:absolute;bottom:-230px;right:-140px}}.Colors-module__wrapper___2Fack .Colors-module__color-profile___1t69b{cursor:pointer;position:relative}.Colors-module__wrapper___2Fack .Colors-module__color-profile___1t69b h2{position:absolute;z-index:1;color:#fff;transform:translate(-50%,-50%);width:250px;left:50%;top:54%;cursor:pointer}.Colors-module__wrapper___2Fack .Colors-module__color-profile___1t69b h2,.Colors-module__wrapper___2Fack h3{text-transform:uppercase;font-size:14px;text-align:center}.Colors-module__wrapper___2Fack h3{color:#b4bac3}", ""]);

// exports
exports.locals = {
	"wrapper": "Colors-module__wrapper___2Fack",
	"color-profile": "Colors-module__color-profile___1t69b"
};